<ng-container *ngIf="category; else noCategory">
    <h3 matSubheader class="category">
        <span class="name">
            {{category.name}}
        </span>
        <a routerLink="/category/{{category._id}}">
            <mat-icon>view_list</mat-icon>
        </a>
    </h3>
</ng-container>
<ng-template #noCategory>
    <h3 matSubheader class="category">
        <span class="name"> Uncategorized </span>
        <a routerLink="/category/undefined">
            <mat-icon>view_list</mat-icon>
        </a>
    </h3>
</ng-template>
